// Styles
import styles from './LongDistanceTitle.module.css';

export const LongDistanceTitle = ({title}) => {
  return <h3 className={styles.title}>{title}</h3>;
}